import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã code",
    name: "maCode",
    rules: [{required: true, message: "Chưa nhập mã code "}],
    css:css,
    wrapperCol: { xs: 24,sm:15, md: 14, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:9, md: 10, lg: 8, xl: 8},
  },
  {
    type: INPUT,
    label: "Số giờ/tuần",
    name: "soGioTuan",
    rules: [{required: true, message: "Chưa nhập Số giờ/tuần"},
    {
      pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
      message: "Chỉ cho phép nhập số"
    }],
    css:css,
    wrapperCol: { xs: 24,sm:15, md: 14, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:9, md: 10, lg: 8, xl: 8},
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
    disable: false,
    css:css,
    wrapperCol: { xs: 24,sm:15, md: 14, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:9, md: 10, lg: 8, xl: 8},
  },

];
export {dataFields};
